import { borderColor, primaryColor } from '@/styles/variants';
import { Tabs, TabsProps } from '@arco-design/web-react';
import styled from 'styled-components';

type RoundedTabProps = TabsProps;

// 就是定制外观的 arco Tabs, 用法一样
export function RoundedTab(props: RoundedTabProps) {
  return <ArcTabs type="rounded" {...props} />;
}

const ArcTabs = styled(Tabs)`
  overflow: visible;
  .arco-tabs-header {
    border: 1px solid ${borderColor};
    border-radius: 16px;
  }
  .arco-tabs-header-title {
    margin-inline: 0;
  }
  .arco-tabs-header-title-active {
    background-color: ${primaryColor};
    color: #fff;
    &:hover {
      background-color: ${primaryColor};
      opacity: 0.6;
    }
  }
`;
